import { render, staticRenderFns } from "./ksOrder.vue?vue&type=template&id=11a19f3c&scoped=true&"
import script from "./ksOrder.vue?vue&type=script&lang=js&"
export * from "./ksOrder.vue?vue&type=script&lang=js&"
import style0 from "./ksOrder.vue?vue&type=style&index=0&id=11a19f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a19f3c",
  null
  
)

export default component.exports